import { defineStore } from 'pinia'
import { api } from '@/api/axios'
import { getToken } from '@/utils/tokenStorage'

export const useVariablesStore = defineStore('variables', {
  state: () => ({
    valor: []
  }),
  actions: {
    async getValorVariable(variable, defaultValue = 1) {
      try {
        const response = await api.post(
          '/variables/get-hotel',
          { variable, default: defaultValue },
          {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          }
        )
        this.valor = response.data.value
        return this.valor
      } catch (error) {
        console.error('Error al obtener tarjetas:', error)
        throw error
      }
    },
    async setValorVariable(variable, value = 1) {
      try {
        const response = await api.post(
          '/variables/set-hotel',
          { variable, valor: value },
          {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          }
        )
        this.valor = response.data.value
        return this.valor
      } catch (error) {
        console.error('Error al obtener tarjetas:', error)
        throw error
      }
    }
  }
})
